import { useContext } from "react";
import { apiUrls } from "../../utils/apiUrls";
import { EditableTable } from "../generic/editableTable/editableTable.component";
import { Table, Checkbox } from "rsuite";
import { WtaHeaderCell } from "../generic/editableTable/editableTable.component";
import { EditableActionCell } from "../generic/editableTable/editableActionCell.component";
import { EditableCheckBoxCell } from "../generic/editableTable/editableCheckboxCell.component";
import { deleteData, getData, postData } from "../../utils/reusables";
import {
  iTypeFormCategories,
  notificationContextTypes,
  typeFormDto,
} from "../../utils/typeDefs";
import { TitleCell } from "../generic/editableTable/titleCell.component";
import { NotificationContext } from "../../core/context/notificationContextProvider";

type formTableProps = {
  data: typeFormDto[] | null;
  currentCountryId: number | null;
  setSearchData: (value: typeFormDto[] | null) => void;
  reviewIds: number[] | [];
  setReviewIds: (value: number[]) => void;
  url: string;
  formCategoryData?: iTypeFormCategories[];
  modalType: string | null;
  setModalType: (value: string | null) => void;
  urlId: number;
  setUrlId: (value: number) => void;
  handleEdit: () => void;
  handleDelete: () => void;
  handleCheckBoxAll: (value: boolean) => void;
};

const { Column, Cell, HeaderCell } = Table;

const FormRegTable = ({
  data,
  currentCountryId,
  setSearchData,
  reviewIds,
  setReviewIds,
  url,
  formCategoryData,
  modalType,
  urlId,
  setUrlId,
  handleEdit,
  handleDelete,
  handleCheckBoxAll,
  setModalType,
}: formTableProps) => {
  const { triggerNotification } = useContext(
    NotificationContext
  ) as notificationContextTypes;

  const verticalMid = "middle";
  const centerAlign = "center";

  const handleConfirm = () => {
    var param = {
      id:urlId
    }
    if (modalType === "delete") {
      postData(
        url === "Form"
          ? apiUrls.form.deleteForm
          : apiUrls.regulation.deleteRegulation,param
      )
        .then((result) => {
          triggerNotification(
            result.data.succeeded,
            url === "Form"
              ? "Successfully deleted form"
              : "Successfully deleted regulation"
          );
          if (result.data.succeeded) {
            setSearchData(null);
            return true;
          } else {
            setSearchData(data);
            return false;
          }
        })
        .then((result) => {
          if (result) {
            getData(
              url === "Form"
                ? apiUrls.form.getForms(currentCountryId)
                : apiUrls.regulation.getRegulations(currentCountryId)
            ).then((result) => setSearchData(result.data));
          }
        })
        .catch((error) => {
          const reason = JSON.parse(error.message);
          triggerNotification(false, reason.data);
        });
    }
  };

  return (
    <>
      <EditableTable
        loading={data === null}
        data={data ? data : []}
        headerHeight={60}
        wordWrap={"break-word"}
        virtualized={true}
      >
        <Column align={centerAlign} width={40} verticalAlign={verticalMid}>
          <WtaHeaderCell>
            <Checkbox
              inline
              disabled={data === null}
              checked={
                reviewIds.length !== 0 &&
                data &&
                reviewIds.length === data.length
                  ? true
                  : false
              }
              onChange={(value, checked) => {
                handleCheckBoxAll(checked);
              }}
            />
          </WtaHeaderCell>
          <EditableCheckBoxCell dataKey="checked" setReviewIds={setReviewIds} />
        </Column>
        <Column width={60} verticalAlign={verticalMid}>
          <WtaHeaderCell>Action</WtaHeaderCell>
          <EditableActionCell
            modalType={modalType}
            formCategoryData={formCategoryData}
            dataKey="id"
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            setUrlId={setUrlId}
            handleConfirm={handleConfirm}
            setData={setSearchData}
            url={url}
            setModalType={setModalType}
          />
        </Column>
        <Column flexGrow={1.3} verticalAlign={verticalMid}>
          <WtaHeaderCell>Title</WtaHeaderCell>
          <TitleCell className="titleColumn" dataKey={`title`} url={url} />
        </Column>
        <Column flexGrow={1.5} verticalAlign={verticalMid}>
          <HeaderCell>Description</HeaderCell>
          <Cell dataKey="description" />
        </Column>
        <Column flexGrow={1} verticalAlign={verticalMid}>
          <WtaHeaderCell>Entry Force</WtaHeaderCell>
          <Cell dataKey="entryIntoForce" />
        </Column>
        <Column flexGrow={1} verticalAlign={verticalMid}>
          <WtaHeaderCell>Last Reviewed</WtaHeaderCell>
          <Cell dataKey="lastReview" />
        </Column>
        <Column flexGrow={0.5} verticalAlign={verticalMid}>
          <WtaHeaderCell>Year</WtaHeaderCell>
          <Cell dataKey="year" />
        </Column>
        <Column flexGrow={0.7} verticalAlign={verticalMid}>
          <WtaHeaderCell>Language</WtaHeaderCell>
          <Cell dataKey="titleLanguage" />
        </Column>
        <Column flexGrow={0.7} verticalAlign={verticalMid}>
          <WtaHeaderCell>Translated Language</WtaHeaderCell>
          <Cell dataKey="translationTitleLanguage" />
        </Column>
      </EditableTable>
    </>
  );
};

export default FormRegTable;
